export default __webpack_public_path__ + "static/media/xiongqi.bd85fec4.png";